<template>
	<div class="stripe-payment">
		<div id="payment-element" />
	</div>
</template>

<script>
import { loadStripe } from "@stripe/stripe-js";
import { formatString } from "@/stringutilities";

import { log } from "@/logging";
const myLoggingName = "StripeCheckout";

export default {
	data() {
		return {
			stripe: null,
			checkout: null,
			checkoutElement: null
		};
	},
	props: {
		config: Object,
		priceId: String,
		//JM ked-362 Added for proper quantities of tickets
		priceQuantity: String,
		addonPriceId: String,
		//JM ked-362 added for proper quantities of addons
		addonPriceQuantity: String,
		receipt_email: String
	},
	inject: ["authService", "configService"],
	name: "StripeCheckout",
	computed: {},
	async mounted() {
		this.$emit("loading", true);

		const mode = this.config.mode;

		const paymentApiURL = formatString(this.config.paymentApiTemplate, {
			hostName: this.configService.getHostName().split(".")[0],
			region: this.config.paymentRegion
		});

		const { publishableKey } = await fetch(`${paymentApiURL}/config?mode=${mode}`, {
			method: "get",
			headers: {
				"Content-Type": "application/json",
				Authorization: this.authService?.token,
			},
			mode: "cors"
		})
			.then(res => res.json())
			.catch(err => {
				log(myLoggingName, "paymentApiConfig", "errorInRequest", err);
			});

		const stripeConfig = { locale: "en-CA" };

		this.stripe = await loadStripe(publishableKey, stripeConfig);
		const prices = [
			{
				//JM ked-362 update to reflect the proper quantity chosen by user
				//quantity: 1,
				quantity: this.priceQuantity,
				priceId: this.priceId
			}
		];

		if (this.addonPriceId) {
			prices.push({
				//JM ked-362 update to reflect the proper quantity chosen by user
				//quantity: 1,
				quantity: this.addonPriceQuantity,
				priceId: this.addonPriceId
			});
		}

		this.checkout = await fetch(`${paymentApiURL}/checkout?mode=${mode}`, {
			method: "post",
			headers: {
				"Content-Type": "application/json",
				Authorization: this.authService?.token
			},
			mode: "cors",
			body: JSON.stringify({
				receipt_email: this.receipt_email,
				prices,
				taxRateId: this.config.environment[mode].stripeTaxRateId,
				enableCoupon: this.config.environment[mode].enableCoupon,
				serviceFeePercentage: this.config.environment[mode].serviceFeePercentage
			})
		})
			.then(res => res.json())
			.catch(err => {
				log(myLoggingName, "paymentApiCreateIntent", "errorInRequest", err);
			});

		this.checkoutElement = await this.stripe.initEmbeddedCheckout({
			clientSecret: this.checkout.client_secret,
			onComplete: async () => {
				const data = await fetch(`${paymentApiURL}/checkout?session_id=${this.checkout.id}&mode=${mode}`, {
					method: "get",
					headers: {
						"Content-Type": "application/json",
						Authorization: this.authService?.token
					},
					mode: "cors"
				})
					.then(res => res.json())
					.catch(err => {
						log(myLoggingName, "paymentCheckoutRetrieve", "errorInRequest", err);
					});

				this.$emit("complete", {
					...data,
					virtual_venue_custom_data: this.checkout.virtual_venue_custom_data
				});
			}
		});

		this.checkoutElement.mount("#payment-element");

		this.$emit("loading", false);
	},
	async beforeUnmount() {
		if (this.checkoutElement) {
			await this.checkoutElement.unmount();
			await this.checkoutElement.destroy();
			this.checkoutElement = null;
		}
	},
	methods: {
		async destroyCheckout() {
			if (this.checkoutElement) {
				await this.checkoutElement.unmount();
				await this.checkoutElement.destroy();
				this.checkoutElement = null;
			}
		}
	}
};
</script>

<style scoped lang="scss">
@import "../../scss/constants";

.stripe-payment {
	margin: 12px 0 24px;
}
</style>
